import React from "react";
export var ScoreIdsInput = /*#__PURE__*/ React.forwardRef(function BaseScoreIdsInput(param, ref) {
    var metricsClassName = param.metricsClassName, title = param.title, values = param.values, percent = param.percent, placeholder = param.placeholder, _param_testidPrefix = param.testidPrefix, testidPrefix = _param_testidPrefix === void 0 ? "score-ids" : _param_testidPrefix, onChange = param.onChange, name = param.name;
    var formattedValues = (values || []).join("\n");
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h5", null, title, /*#__PURE__*/ React.createElement("span", {
        "data-testid": "".concat(testidPrefix, "-metrics"),
        className: metricsClassName
    }, values.length, percent)), /*#__PURE__*/ React.createElement("textarea", {
        ref: ref,
        onChange: onChange,
        name: name,
        readOnly: !onChange,
        value: !onChange ? formattedValues : undefined,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: false,
        placeholder: placeholder,
        "data-testid": "".concat(testidPrefix, "-textarea")
    }));
});
